// extracted by mini-css-extract-plugin
export default {"wrap":"Ur-z","fullWidth":"Vr-z","items":"Wr-z","featureCss":"Xr-z","disabled":"Yr-z","imgCss":"Zr-z"};